import React from 'react'
import logo from '../../../images/logo.webp'
import banner from '../../../images/aurum/aurum_banner.webp'
import aurum_1 from '../../../images/aurum/aurum1.webp'
import aurum_2 from '../../../images/aurum/aurum2.webp'
import aurum_3 from '../../../images/aurum/aurum3.webp'
import aurum_4 from '../../../images/aurum/aurum4.webp'
import aurum_5 from '../../../images/aurum/aurum5.webp'
import aurum_6 from '../../../images/aurum/aurum6.webp'
import aurum_7 from '../../../images/aurum/aurum7.webp'
import aurum_8 from '../../../images/aurum/aurum8.webp'
import aurum_9 from '../../../images/aurum/aurum9.webp'
import aurum_10 from '../../../images/aurum/aurum10.webp'
import aurum_11 from '../../../images/aurum/aurum11.webp'
import aurum_12 from '../../../images/aurum/aurum12.webp'
import aurum_13 from '../../../images/aurum/aurum13.webp'
import aurum_14 from '../../../images/aurum/aurum14.webp'
import aurum_15 from '../../../images/aurum/aurum15.webp'
import aurum_16 from '../../../images/aurum/aurum16.webp'
import { FaSearch } from "react-icons/fa";
import { IoBag } from "react-icons/io5";
import { FaRegHeart } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { FaBell } from "react-icons/fa";

const Aurum = () => {
  return (
   <>
   <div className="bg-aurum_secondary py-2">
  <div className="container mx-auto grid grid-cols-2">
    <div className="text-lg font-semibold">Today's Metal Rate</div>
    <div className="flex justify-end items-center text-lg font-semibold">Plan Your Investment</div>
  </div>
</div>


<div className="container mx-auto flex items-center justify-between py-4">
  <div className="flex items-center">
    <img className="w-64 h-24" src={logo} alt="img" /> 
  </div>

  <div className="flex-1 px-4">
  <div className="relative flex items-center justify-center w-full">
  <input type="text" placeholder="Search..." className="border border-gray-300 rounded-lg p-4 pr-12 w-2/3"/>
    <FaSearch className="absolute right-40 mr-3 text-gray-400 bg-aurum_primary p-2 w-14 h-full rounded text-white" />
  </div>
</div>

  <div className="flex items-center"> 
    <div className="flex flex-col items-center mr-4"> 
      <IoBag className="text-[25px]" /> 
      <span className="text-md font-semibold">Cart</span>
    </div>

    <div className="flex flex-col items-center mr-4"> 
      <FaRegHeart className="text-[25px]" /> 
      <span className="text-md font-semibold">Wishlist</span>
    </div>

    <div className="flex flex-col items-center"> 
      <FaUser className="text-[25px]" /> 
      <span className="text-md font-semibold">Login</span>
    </div>
  </div>
</div>




<div className="bg-aurum_secondary">
<div class="container mx-auto text-md flex items-center space-x-8">
<div class="flex items-center">
  <h1 class="bg-aurum_primary text-white px-4 py-2 rounded flex items-center"><FaBars class="mr-2"/>Categories</h1>
</div>

    <ul class="list-none p-0 m-0 flex space-x-10 font-semibold">
        <li>Home</li>
        <li>About Us</li>
        <li>Contact Us</li>
        <li>Gold Plan</li>
    </ul>
</div>
</div>

{/* End of Header Section */}

 

<div className="">
    <img className="image" src={banner} alt="banner-image"></img>
</div>

{/* End of Banner Content */}

<div className="flex justify-center text-2xl font-semibold my-7">Adornments That Capture Hearts</div>

<div className="container mx-auto grid grid-cols-4 gap-4">
  <div className="flex justify-center">
   <img className="image" src={aurum_1} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={aurum_2} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={aurum_3} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={aurum_4} alt="img"></img></div>
</div>

{/* End of section1 */} 


<div className="flex justify-center text-2xl font-semibold my-7">Jewelry That Resonates with You</div>

<div class="container mx-auto flex gap-4">
  <div className="w-3/13 flex justify-center  ">
  <img className="image" src={aurum_5} alt="img"></img>
  </div>
  <div className="w-7/13   flex justify-center">
  <img className="image" src={aurum_7} alt="img"></img>
  </div>
  <div className="w-3/13  flex justify-center">
  <img className="image" src={aurum_6} alt="img"></img>
  </div>
</div>

{/* End of section2 */} 


<div className="flex justify-center text-2xl font-semibold my-7">Simplicity Elevated to Splendor</div>
<div className=" container mx-auto ">
<img className="image" src={aurum_8} alt="img"></img>
 </div> 

     {/* End of section3 */}



     <div className="flex justify-center text-2xl font-semibold my-7">Inspired by Beauty, Perfected for You</div>

      <div className=" container mx-auto grid grid-cols-5 gap-4">
        <div className="justify-self-center">
        <img className="image" src={aurum_9} alt="img"></img>
        <p className=" flex justify-center font-semibold my-7 ">Pendant</p></div>
     
        <div className="justify-self-center">
        <img className="image" src={aurum_13} alt="img"></img>
        <p className=" flex justify-center font-semibold my-7">Barcelet</p></div>
     
         <div className="justify-self-center">
        <img className="image" src={aurum_11} alt="img"></img>
        <p className=" flex justify-center font-semibold my-7">Tali</p></div>
     
          <div className="justify-self-center">
        <img className="image" src={aurum_12} alt="img"></img>
        <p className=" flex justify-center font-semibold my-7">Flex Bangles</p></div>
     
          <div className="justify-self-center">
        <img className="image" src={aurum_10} alt="img"></img>
        <p className=" flex justify-center font-semibold  my-7">Pendant</p></div>
        </div>

   {/* End of section4 */}


   <div className="flex justify-center text-2xl font-semibold my-7">The Essence of Timeless Glamour</div>
<div className="container mx-auto  flex gap-4">
  <div className="w-1/2 ">
  <img className="image" src={aurum_14} alt="img"></img>
  </div>
  <div className="w-1/2 flex flex-col gap-4">
    <div className="h-1/2 ">
    <img className="image" src={aurum_15} alt="img"></img>
    </div>
    <div className="h-1/2 ">
    <img className="image" src={aurum_16} alt="img"></img>
    </div>
  </div>
</div>


              {/* End of section5 */}

<div className="bg-aurum_primary w-full mt-5">
  <div className="container mx-auto py-4">
    <div className="grid grid-cols-2 gap-8">
    <article className="text-white flex items-center space-x-4">
  <div className="flex items-center justify-center border border-slate-50 rounded-full bg-slate-50 w-10 h-10">
    <FaBell className="text-black" />
  </div>
  <div>
    <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
    <p>Get all the latest information on Events, Sales and Offers.</p>
  </div>
</article>


      <form className="flex items-center">
        <input type="email" id="email" name="email" placeholder="Enter your email" className="w-full px-3 py-2 border rounded-lg mr-2"></input>
        <button type="submit" className="bg-aurum_secondary text-black font-semibold px-4 py-2 rounded-lg">
          <span>SUBSCRIBE</span>
        </button>
      </form>
    </div>
  </div> 
  
</div>
<div className="bg-aurum_secondary grid grid-cols-3 gap-4 ">
  <div className="flex justify-center">
<img className="image w-64 h-24  " src={logo} alt="img"></img>
</div>

<div>
  <h2 className="my-4 text-black font-semibold">GET US HELP YOU</h2>
<ul className="list-none p-0 m-0">
    <li className="py-2 ">Contact Us</li>
    <li className="py-2">Terms and Condition</li>
    <li className="py-2">FAQ</li>
</ul>
</div>

<div>
  <h2 className="my-4 text-black font-semibold">OUR POLICIES</h2>
<ul className="list-none p-0 m-0 ">
<li className="py-2 ">Privacy Policy</li>
    <li className="py-2">Shipping Policy</li>
    <li className="py-2 ">Cancellation Policy</li>
    <li className="py-2 ">Exchange Policy</li>

</ul>
</div>

</div>

<div className=" bg-aurum_primary ">
  <div className="container mx-auto text-white">ⓒ All rights reserved</div>
</div>

{/* End of footer section */}


   </>
  )
}

export default Aurum;
